import { CircularProgress, Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import BatchDetail from './BatchDetail';
import CancelledItemDetail from './CancelledItemDetail';
import Header from '@/component/Header';
import MerchantDetail from './MerchantDetail';
import OrderAppLib from 'dimorder-orderapp-lib';
import OrderOverview from './OrderOverview';
import PaymentDetail from './PaymentDetail';
import PriceDetail from './PriceDetail';
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import dimorderApi from '@/libs/api/dimorderApi';

export default function OrderDetail() {
  const { i18n } = useTranslation();
  const orderId = window.location.pathname.replace('/', '');
  const [orderDetail, setOrderDetail] = useState(null);
  const [merchantDetail, setMerchantDetail] = useState(null);
  const [paymentMethods, setPaymentMethods] = useState(null);
  const [apiFail, setApiFail] = useState(false);
  const url = new URL(window.location.href);
  const lang = url.searchParams.get('lang');

  const languageMap = [
    'zh-HK',
    'en-US',
    'zh-TW',
    'th-TH',
  ];
  if (lang && !languageMap.includes(lang)) {
    return <div>Not Found</div>;
  }

  useEffect(() => {
    if (lang) {
      localStorage.setItem('i18nextLng', lang);
      i18n.changeLanguage(lang);
    }
  }, [lang]);

  const getOrder = async () => {
    try {
      const orderRes = await dimorderApi.getOrderDetail(orderId);
      setOrderDetail(orderRes);
    } catch (error) {
      console.error(error);
      setApiFail(true);
    }
  };

  const getMerchant = async (merchantId) => {
    try {
      const merchantRes = await dimorderApi.getMerchantDetail(merchantId);
      setMerchantDetail(merchantRes);
      setPaymentMethods(merchantRes?.payments);
    } catch (error) {
      console.error(error);
      setApiFail(true);
    }
  };

  // 1) 首次載入與輪詢（記得清除 interval）
  useEffect(() => {
    if (merchantDetail) {
      const id = setInterval(getOrder, 30000);
      return () => clearInterval(id);
    }
  }, [merchantDetail]); // ← 只在掛載/卸載時跑

  // 2) 當 orderDetail 的 merchantId 改變時才抓 merchant
  useEffect(() => {
    if (orderDetail?.merchantId) {
      getMerchant(orderDetail.merchantId);
    }
  }, [orderDetail?.merchantId]);

  useEffect(() => {
    getOrder();
  }, [i18n.language]);

  const sortReceiptItemByCategory = false;
  const receiptGroupBy = 'batch';
  const summarySettings = { sortReceiptItemByCategory, receiptGroupBy };

  const appOrder = orderDetail ? OrderAppLib.libs.apiOrderToAppOrder(orderDetail) : null;
  const summary = appOrder ? OrderAppLib.libs.formatSummary(appOrder, summarySettings) : null;
  const groupedSummary = summary ? _.groupBy(summary, (o) => o.batchId) : {};
  const cancelledItems = orderDetail ? orderDetail.items.filter((item) => item.cancelled) : [];

  return (
    <>
      <Header />

      {orderDetail && merchantDetail && (
        <Grid container justifyContent='center' direction='row'>
          <Grid item xs={12} sm={10} md={4} lg={4} xl={4}>
            <MerchantDetail data={merchantDetail} />
            <OrderOverview data={orderDetail} />
            {orderDetail?.batches?.map((batch) => (
              <div key={batch.batchId}>
                <BatchDetail
                  batch={batch}
                  summary={groupedSummary[batch.batchId]}
                  currencySymbol={orderDetail?.currency}
                  rounding={orderDetail?.rounding}
                />
              </div>
            ))}
            <PriceDetail data={orderDetail} />
          </Grid>

          {orderDetail?.apiVersion === '2.0.0' && orderDetail?.payments?.length > 0 && (
            <Grid item xs={12} sm={10} md={4} lg={4} xl={3}>
              <PaymentDetail data={orderDetail} paymentMethods={paymentMethods} />
            </Grid>
          )}

          {cancelledItems.length > 0 && (
            <Grid item xs={12} sm={10} md={4} lg={4} xl={5}>
              <CancelledItemDetail data={cancelledItems} />
            </Grid>
          )}
        </Grid>
      )}

      {!(orderDetail && merchantDetail) && !apiFail && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '90vh' }}>
          <CircularProgress size={70} />
        </div>
      )}
    </>
  );
}
